<gpu-radio-group formControlName="select" (ngModelChange)="track()">
  <gpu-radio-button
    *ngFor="let answer of question.answers"
    id="option_0_{{ answer.id }}"
    name="value0"
    class="gmt-12 gmb-24 d-block"
    [value]="answer.id"
  >
    {{ split(answer?.name, 0) }}
    <ng-container *ngIf="answer.type == 'Input' && split(answer?.name, 1)">
      <gpu-form-field
        class="gmx-8"
        style="max-width: 60px"
        [appearance]="formFieldAppearance"
      >
        <input
          id="input_0_{{ answer.id }}"
          name="input_0_{{ answer.id }}"
          type="text"
          gpuInput
          gpuLocalNumber
          formControlName="input"
          (blur)="track(true)"
        />
      </gpu-form-field>
      {{ split(answer?.name, 1) }}
    </ng-container>
  </gpu-radio-button>
</gpu-radio-group>
